<template>
  <div v-if="isLoaded">
    <transition>
      <div class="row" v-if="unitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-end" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-end">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              v-model="formData.termin"
              :disabled="isBilled || isCoachBilled"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  v-model="formData.startTime"
                  :key="startTimeKey"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                  label="Startzeit"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  v-model="formData.endTime"
                  :key="endTimeKey"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                  label="Endzeit"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :options="presenceDropdown"
                     :disabled="isBilled || isCoachBilled"
                     :required="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"
                     @update:modelValue="calculateTimeDifference"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseCheckbox
              v-model="formData.overwrite"
              :disabled="isBilled || isCoachBilled"
              :validation="v$.overwrite"
              label="Überschreiben"
              @update:modelValue="calculateTimeDifference"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.coachType"
                     :disabled="isBilled || isCoachBilled"
                     :options="coachTypeDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coachart"
                     placeholder="Wählen Sie Coachart"
                     :validation="v$.coachType"
                     :messages="v$.coachType.required.$message"
                     @update:modelValue="calculateTimeDifference"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                v-model="formData.signature"
                :disabled="isBilled || isCoachBilled || isDigitalSignature"
                label="Unterschrift"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class="mt-4">
            <BaseCheckbox
                v-model="formData.billed"
                :disabled="isBilled || isCoachBilled"
                label="Abgerechnet"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class=" mt-4">
            <BaseCheckbox
                v-model="formData.paid"
                :disabled="isBilled || isCoachBilled"
                label="Bezahlt"
                :labelPosition="'right'"/>
          </div>
        </div>

        <div v-if="operationType === 'sociotherapie'" class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                v-model="formData.homeVisit"
                :disabled="isBilled || isCoachBilled"
                label="Hausbesuch"
                :labelPosition="'right'"/>
          </div>
        </div>
      </div>
      <div class="row mt-3 pt-3" style="border-top: 1px solid #ddd">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <SelectVue v-model="formData.meetingType"
                     :disabled="isBilled || isCoachBilled"
                     :options="meetingTypeDropdown"
                     :is-clear="true"
                     label="Art des Termins"
                     placeholder="Wählen Sie Art des Termins"
                     :validation="v$.meetingType"
                     :messages="v$.meetingType.required.$message"
                     @update:modelValue="calculateTimeDifference"/>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12"
             v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT'">
          <SelectVue v-model="formData.coachId"
                     :disabled="isCoachBilled"
                     :options="coachDropdown"
                     :is-clear="true"
                     label="Coach"
                     placeholder="Trainer auswählen"/>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput v-model="formData.meetingTopic"
                     label="Sitzungsthema"
                     :required="true"
                     :validation="v$.meetingTopic"
                     :messages="v$.meetingTopic.required.$message"/>

          <SelectVue v-model="formData.contentOfMeasure"
                     :options="contentOfMeasureDropdown"
                     :is-clear="true"
                     :is-multi="true"
                     label="Ziel/ Inhalt der Maßnahme"/>

          <SelectVue v-if="operationType === 'sociotherapie'"
                     v-model="formData.peopleInvolved"
                     :options="peopleInvolvedDropdown"
                     :is-clear="true"
                     :is-multi="true"
                     label="Beteiligte Personen (P/T /+ weitere)"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-end mt-3">
          <BaseCheckbox
              v-model="formData.geva"
              label="Geva-Potentialanalyse"
              :labelPosition="'right'"
              :messages="v$.overwrite.$errors.map((err) => err.$message).join(', ')"
              :disabled="isBilled || isCoachBilled"/>
        </div>
      </div>

      <div v-if="!unitsErrorMessage" class="d-flex justify-content-center w-100 mt-2">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import portalSocioTherapyCoachingService from '@/api/Portal/SocioTherapyCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {addDeletedCoachToDropdown} from '@/shared/portal/commonFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import BaseToggle from "@/components/base/BaseToggle.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const coachTypeDropdown = ref([]);
const meetingTypeDropdown = ref([]);
const meetingType1Enums = ref([]);
const meetingType2Enums = ref([]);
const contentOfMeasureDropdown = ref([]);
const peopleInvolvedDropdown = ref([]);
const unitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const currentPresenceType = ref(null);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);

const updateAsAdmin = ref(false) // Need this for update as admin logic
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  coachData: {
    type: Object,
    required: true
  },
  protocolId: {
    type: Number,
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  isDigitalSignature: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const coachData = toRefs(props)['coachData'];
const protocolId = toRefs(props)['protocolId'];
const operationType = toRefs(props)['operationType'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  meetingType: '',
  overwrite: false,
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  contentOfMeasure: [],
  peopleInvolved: [],
  geva: false,
  meetingTopic: '',
  description: '',
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  meetingType: requiredRule(t),
  overwrite: requiredRule(t),
  units: requiredRule(t),
  signature: requiredRule(t),
  billed: requiredRule(t),
  paid: requiredRule(t),
  homeVisit: requiredRule(t),
  meetingTopic: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer

    if (props.protocolId) {
      if (updateAsAdmin.value) {
        await portalSocioTherapyCoachingService.updateProtocolAsAdmin(
            formData.value,
            +protocolId.value
        )
      } else {
        await portalSocioTherapyCoachingService.updateProtocol(
            formData.value,
            +protocolId.value
        )
      }
    } else {
      await portalSocioTherapyCoachingService.postProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalSocioTherapyCoachingService.getProtocol(protocolId.value);
    const protocol = data.data;
    const coach = protocol?.coach;

    isBilled.value = protocol.invoiced;
    isCoachBilled.value = protocol.coachInvoiced;

    // Save original values
    originalIsBilled.value = data.data.invoiced;
    originalIsCoachBilled.value = data.data.coachInvoiced;

    if (Array.isArray(coach) && coach.length > 0) {
      coachDropdown.value = [
        {
          label: `${coach.firstName} ${coach.lastName}`,
          value: coach.id,
        },
      ];
    }

    addDeletedCoachToDropdown(coach, coachDropdown);

    // On creates only anwesend, unentschuldigt for both types !!!!
    // On edit, we need to show selected presence if it is not one of these two types
    const currentPresence = protocol.presence;
    const currentPresenceTranslation = protocol.presenceTranslation;
    if (currentPresence === 'krank' || currentPresence === 'entschuldigt') {
      presenceDropdown.value.push({
        value: currentPresence,
        label: currentPresenceTranslation,
      });
    }

    // Coach type dropdown
    // On creation only soziotherapie for both types !!!
    // On edit, we need to show selected value if it is not soziotherapie
    const currentCoachType = protocol.coachType;
    const currentCoachTypeTranslation = protocol.coachTypeTranslation;
    if (currentCoachType !== null && !coachTypeDropdown.value.includes(currentCoachType)) {
      coachTypeDropdown.value.push({
        value: currentCoachType,
        label: currentCoachTypeTranslation,
      });
    }

    // Meeting type dropdown
    // On edit, we need to add 'initial_consultation' if is selected
    const currentMeetingType = protocol.meetingType;
    if (operationType.value === 'sociotherapie') {
      if (currentMeetingType === 'initial_consultation') {
        meetingType2Enums.value.push(currentMeetingType);
      }
    }

    formData.value = {
      ...protocol,
      coachId: coach?.id,
    };

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));
  } catch (error) {
    await ErrorToast(error);
  }
}

const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    const meetingType = formData.value.meetingType;
    const unitDuration = 50;
    let units = (diffMinutes / 50).toPrecision(3).substring(0, 4);
    units = parseFloat(units);

    onChangeUnits(units);

    // Check a presence type
    if ((formData.value.presence)) {
      if (formData.value.presence === 'anwesend') {
        units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
      } else {
        units = 1;
      }
    }

    // If presenceType is selected and overview is true, calculate units
    if (formData.value.overwrite === true) {
      units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
    }

    if (units > 0 && meetingType) {
      onChangeMeetingType(units);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
  } else {
    unitsErrorMessage.value = '';
  }
}

function onChangeMeetingType(units) {
  // SOCIO THERAPY
  if (operationType.value === 'sociotherapie') {
    let fullMeetingHours = units * 50; // Important !!!

    if (formData.value.meetingType === 'trial_lesson') { // meeting must be a full unit !!!!!
      if (units !== 1) {
        if ((fullMeetingHours !== 0) && (fullMeetingHours % 50 === 0)) {
          unitsErrorMessage.value = '';
        } else {
          unitsErrorMessage.value = 'Probestunden müssen in vollen Einheiten angerechnet werden. ' +
              'Bitte passe deinen Eintrag an.';
        }
      }
    } else {
      if (fullMeetingHours % 10 === 0 || fullMeetingHours % 25 === 0) { // increase in interval 10 or 25 minutes
        unitsErrorMessage.value = '';
      } else {
        unitsErrorMessage.value = 'Termine können nur in 10/25 Minuten Taktung abgerechnet werden, ' +
            'daher muss dein gewähltes Zeitfenster bitte angepasst werden.';
      }
    }
  } else { //SOCIO THERAPY PRIMARY TYPE
    // Multiplying meetingHours by 10 could be a way to avoid working with fractional values
    // (e.g., 1.5 hours become 15).
    let fullMeetingHours = units * 10;
    if (fullMeetingHours % 5 === 0) {
      unitsErrorMessage.value = '';
    } else {
      unitsErrorMessage.value = 'Termine können nur in 25/50 Minuten Taktung abgerechnet werden, ' +
          'daher muss dein gewähltes Zeitfenster bitte angepasst werden.';
    }
  }
}

//watch(
//    () => [
//      formData.value.startTime,
//      formData.value.endTime,
//      formData.value.presence,
//      formData.value.overwrite,
//      formData.value.meetingType,
//    ],
//    calculateTimeDifference,
//);

async function getEnumsDropdown() {

  // 1. PRESENCE DROPDOWN
  // On creates only anwesend, unentschuldigt for both type !!!!
  const allowedPresences = ['anwesend', 'unentschuldigt'];
  presenceDropdown.value = (getEnums?.value?.presenceTypes || []).filter(item =>
      allowedPresences.includes(item.value),
  );

  // 2. COACH TYPE DROPDOWN !!!
  // On creation only soziotherapie for both type !!!
  coachTypeDropdown.value = (getEnums?.value?.portalCoachTypes || []).filter(
      item => item.value === 'soziotherapie',
  );

  // 3. MEETING TYPE DROPDOWN !!!
  // For operationType 'sociotherapie' we have only two types on creation (trial_lesson, sociotherapy)
  if (operationType.value === 'sociotherapie') {
    const allowedMeetingTypes2 = ['trial_lesson', 'sociotherapy'];
    meetingType2Enums.value = (getEnums?.value?.socioTherapyMeetingTypes2 || []).filter(item =>
        allowedMeetingTypes2.includes(item.value),
    );
  }

  // For operationType 'sociotherapie_primary' we take all from enums
  if (operationType.value === 'sociotherapie_primary') {
    meetingType1Enums.value = getEnums?.value?.socioTherapyMeetingTypes || [];
  }

  contentOfMeasureDropdown.value = getEnums?.value?.contentOfMeasures || [];
  peopleInvolvedDropdown.value = getEnums?.value?.peopleInvolved || [];
}

watch(formData.value, () => {
  if (!formData.value.contentOfMeasure.includes(1)) {
    formData.value.contentOfMeasure.push(1);
  }

  if (operationType.value === 'sociotherapie') {
    if (!formData.value.peopleInvolved.includes('patient')) {
      formData.value.peopleInvolved.push('patient');
    }
  }
});

function getCoachDropdownData(){
  coachDropdown.value = [
    {
      label: `${coachData.value.firstName} ${coachData.value.lastName}`,
      value: coachData.value.id,
    },
  ];
}

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    (originalIsBilled.value || originalIsCoachBilled.value)
);

onMounted(async () => {
  CloseToast()
  getCoachDropdownData();
  await getEnumsDropdown();

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  // Important !!!!
  if (operationType.value === 'sociotherapie') {
    meetingTypeDropdown.value = meetingType2Enums.value;
  } else {
    meetingTypeDropdown.value = meetingType1Enums.value;
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>